/**
 * Mode de localisation du funnel, piloté par l'attribut `localisation` du custom
 * element <komilfo-funnel>. Axe orthogonal à `variant` (produits).
 *
 *   "magasin" : sélecteurs région → magasin. DÉFAUT depuis le 2026-07-29.
 *   "cp"      : saisie code postal → commune (flux historique), joignable via
 *               localisation="cp" — échappatoire par page en cas de rollback.
 */
export type LocalisationMode = "cp" | "magasin";

const DEFAULT_MODE: LocalisationMode = "magasin";

export function getLocalisationMode(attr?: string | null): LocalisationMode {
  const value = (attr ?? "").trim().toLowerCase();
  if (value === "magasin") return "magasin";
  if (value === "cp") return "cp";
  return DEFAULT_MODE;
}
